'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentModels = exports.ContentModel = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp2;

var _mobx = require('mobx');

var _baseContentmodel = require('base-contentmodel');

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _deepExtend = require('deep-extend');

var _deepExtend2 = _interopRequireDefault(_deepExtend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var ContentModel = exports.ContentModel = (_class = (_temp2 = _class2 = function (_BaseContentModel) {
  (0, _inherits3.default)(TypeContentModel, _BaseContentModel);

  function TypeContentModel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TypeContentModel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TypeContentModel.__proto__ || (0, _getPrototypeOf2.default)(TypeContentModel)).call.apply(_ref, [this].concat(args))), _this), _this.readonly = true, _this.savable = false, _this.editable = false, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TypeContentModel, [{
    key: 'meta',
    get: function get() {
      return (0, _deepExtend2.default)({
        entities: {
          readonly: this.id === "TypeContentModel"
        }
      }, this.constructor._meta || {});
    }
  }, {
    key: 'entities',
    get: function get() {
      // this.$parent.types[this.id].newEntityWasAdded.get(); // refresh this computed :-)
      return this.$parent.types[this.id].allEntities();
    }
  }, {
    key: 'childConstructor',
    get: function get() {
      return this.$parent.types[this.id];
    }
  }]);
  return TypeContentModel;
}(_baseContentmodel2.default), _class2.Synthetic = true, _class2._slots = {
  entities: [_baseContentmodel2.default]
}, _class2._meta = {}, _temp2), (_applyDecoratedDescriptor(_class.prototype, 'meta', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'meta'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'entities', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'entities'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'childConstructor', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'childConstructor'), _class.prototype)), _class);
var ContentModels = exports.ContentModels = { TypeContentModel: ContentModel };
;

var _temp3 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ContentModel, 'ContentModel', 'src/entity_modules/type-entity/index.js');

  __REACT_HOT_LOADER__.register(ContentModels, 'ContentModels', 'src/entity_modules/type-entity/index.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/entity_modules/type-entity/index.js
// module id = ./node_modules/platform-client-bootstrap/dist/entity_modules/type-entity/index.js
// module chunks = 0